import React, { useCallback } from 'react';
import { useHistory } from 'react-router';

import { toBrazilianFullDate } from 'views/CRM/shared/utils/date';

import './styles.css';

const ContactProtocolsAndOpportunities = ({
  protocols,
  opportunity,
  recordTypeContact,
  contactId
}) => {
  const history = useHistory();

  const handleOnProtocolNameClick = useCallback(
    ({ protocolId, recordTypeId, opportunityId }) => {
      if (protocolId) {
        const values = {
          recordTypeId,
          returnPath: `/admin/crm/contactForm/${recordTypeContact}/${contactId}`
        };
        localStorage.setItem('valueRoute', JSON.stringify(values));
        history.push(`/admin/protocol/${protocolId}/update`);
      } else {
        history.push(
          `/admin/crm/opportunityEdit/${recordTypeId}/${opportunityId}`,
          { recordTypeId }
        );
      }
    },
    [history, contactId, recordTypeContact]
  );

  if (
    (!protocols || !protocols.length) &&
    (!opportunity || !opportunity.length)
  ) {
    return null;
  }

  const isProtocols = protocols && protocols.length > 0;

  const items = isProtocols ? protocols : opportunity;

  return (
    <>
      <div
        style={{
          display: 'flex',
          gap: '0.5rem',
          flexWrap: 'wrap'
        }}
      >
        {items.map((item) => {
          return (
            <div
              key={item.id}
              style={{
                position: 'relative',
                border: '1px solid lightgray',
                borderRadius: '0.1rem',
                borderTop: '0.15rem solid gray',
                padding: '0.8rem',
                width: '24%',
                overflow: 'hidden',
                backgroundColor: '#fff'
              }}
            >
              <div>
                <span
                  className="link-to-protocol-details"
                  onClick={() =>
                    handleOnProtocolNameClick({
                      recordTypeId: item.recordTypeId || item.record_type_id,
                      protocolId: protocols ? item.id : null,
                      opportunityId: opportunity?.length > 0 ? item.id : null
                    })
                  }
                  title={item.title || ''}
                >
                  {isProtocols ? item.number || item.id : item.title}
                </span>
              </div>
              <div className="small">
                <span>
                  <span className="font-weight-bold">Criado em: </span>
                  {toBrazilianFullDate(item.creationDate)}
                </span>
              </div>
              <div className="small">
                <span className="font-weight-bold">Responsável: </span>
                <span>{item?.responsibleName || ''}</span>
              </div>
              <div className="small">
                <span className="font-weight-bold">Tipo de registro: </span>
                <span>{item?.recordTypeName || ''}</span>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default ContactProtocolsAndOpportunities;
